import { flagFactory } from '../icon';
import Svg from './hu.svg';

export default flagFactory(Svg);
